import { gql } from '@apollo/client';

export const GET_ACTIVE_RECOMMENDATION_COUNTS = gql`
  query ActiveRecommendationCounts {
    getActiveRecommendationCounts {
      total
      high
    }
  }
`;
